module.exports = __webpack_public_path__ + "img/roll-869.479f1f35.png";